var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['submenu-drawer', { 'submenu-drawer--open': _vm.open }],attrs:{"id":("submenu-drawer--" + _vm.menuId),"aria-hidden":_vm.open ? 'false' : 'true'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }